import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
const DeallocateHandler = ({ application, children }) => {
    if (application.dealloced) {
        return null;
    }
    return _jsx(_Fragment, { children: children });
};
export default observer(DeallocateHandler);
